if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // required用のバリデーション追加 start
        if (this.form.checkValidity() === false ) {
          const validate_text = document.createElement("p");
          validate_text.classList.add("validate-text");
          validate_text.textContent = "必須項目を入力してください";
          //色変更
          validate_text.style.color = "red";
          // メッセージがすでに表示されていないときにメッセージ表示
          if (this.form.querySelector(".validate-text") === null) {
            this.form.appendChild(validate_text);
            // 3秒後に消す
            setTimeout(function(){
              validate_text.remove();
            }, 3000);
          }
          return;
        } 
        // required用のバリデーション追加 end

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButtonUpdate();
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      submitButtonUpdate() {
        const elem = this.submitButton.closest('[data-main-product]');
        if (!elem) {
          this.quickAddButtonUpdate();
          return;
        }
        console.log(elem);
        const sectionId = elem.getAttribute('data-section');
        if (!sectionId) return;
        console.log(sectionId);

        fetch(`${window.location.pathname}?section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            if (!html) return;
            const newSubmitButton = html.querySelector('.product-form__submit');
            if (!newSubmitButton) return;

            const newSubmitButtonIsDisabled = newSubmitButton.hasAttribute('disabled');

            let newSubmitButtonTarget = this.submitButton;
            let newSubmitButtonText = newSubmitButton.innerHTML;

            // もしnewSubmitButtonTextにspanが入っている場合はspanの中身を取得
            if (newSubmitButtonText.includes('<span')) {
              newSubmitButtonText = newSubmitButton.querySelector('span').innerHTML;
            }

            // もしnewSubmitButtonTargetにspanが入っている場合はspanをターゲットにし直す
            if (newSubmitButtonTarget.querySelector('span')) {
              newSubmitButtonTarget = newSubmitButtonTarget.querySelector('span');
            }

            if (newSubmitButtonIsDisabled) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.setAttribute('disabled', true);
              newSubmitButtonTarget.innerHTML = newSubmitButtonText;
            }

            console.log(newSubmitButton);
            console.log(newSubmitButtonIsDisabled);
            console.log(newSubmitButtonText);
          })
          .catch(e => {
            console.error(e);
          });
      }

      quickAddButtonUpdate() {
        const elem = this.submitButton.closest('[data-product]');
        if (!elem) return;
        console.log(elem);
        const sectionId = elem.getAttribute('data-section');
        if (!sectionId) return;
        console.log(sectionId);
        const productId = elem.getAttribute('data-product-id');

        fetch(`${window.location.pathname}?section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            if (!html) return;
            const newSubmitButton = html.querySelector(`[data-product-id="${productId}"] .product-form__submit`);
            if (!newSubmitButton) return;

            const newSubmitButtonIsDisabled = newSubmitButton.hasAttribute('disabled');

            let newSubmitButtonTarget = this.submitButton;
            let newSubmitButtonText = newSubmitButton.innerHTML;

            // もしnewSubmitButtonTextにspanが入っている場合はspanの中身を取得
            if (newSubmitButtonText.includes('<span')) {
              newSubmitButtonText = newSubmitButton.querySelector('span').innerHTML;
            }

            // もしnewSubmitButtonTargetにspanが入っている場合はspanをターゲットにし直す
            if (newSubmitButtonTarget.querySelector('span')) {
              newSubmitButtonTarget = newSubmitButtonTarget.querySelector('span');
            }

            if (newSubmitButtonIsDisabled) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.setAttribute('disabled', true);
              newSubmitButtonTarget.innerHTML = newSubmitButtonText;
            }

            console.log(newSubmitButton);
            console.log(newSubmitButtonIsDisabled);
            console.log(newSubmitButtonText);
          })
          .catch(e => {
            console.error(e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
